import SectionCounter1 from "../../../sections/home/index/section-counter1";
import { useEffect } from "react";
import { loadScript, publicUrlFor } from "../../../../globals/constants";

import {
  FaMobileAlt,
  FaAndroid,
  FaApple,
  FaPaintBrush,
  FaRocket,
  FaShieldAlt,
  FaCloudUploadAlt,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import Seo from "../../common/Seo";
function MobileAppDevelopmentServicePage() {
  useEffect(() => {
    loadScript("js/custom.js");
  }, []);

  return (
    <>
      <Seo
        title="Mobile App Development Company in Pune | Android & iOS Apps"
        description="Build secure, scalable, and high-performance mobile applications with DArchTech. Expert Android, iOS & cross-platform app development solutions."
      />

      {/* SERVICE DETAIL SECTION START */}
      <div className="section-full p-b80 sx-ser-detail-outer sx-bg-white">
        {/* Banner Section */}
        <div
          className="sx-bnr-1-wrap overlay-overlay"
          style={{
            backgroundImage: `url(${publicUrlFor(
              "images/services/service-detail-mobile-app-dev.jpg"
            )})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "85vh",
            display: "flex",
            alignItems: "center",
            backfaceVisibility: "hidden",
            backgroundBlendMode: "multiply",
            backgroundColor: "rgba(0, 0, 0, 0.15)",
          }}
        >
          <div className="sx-bg-overlay opacity-0 sx-bg-primary" />

          <div className="container">
            <div className="sx-bnr-1-content text-center">
              {/* H1 */}
              <h1
                style={{ fontSize: "7vw" }}
                className="sx-bnr-1-large-title fw-bolder text-light mb-3"
              >
                Mobile App Development Services in Pune
              </h1>

              {/* H2 */}
              <h2 className="sx-bnr-1-info fs-4 text-light mb-4">
                Build Scalable, Secure & High-Performance Mobile Applications
              </h2>

              {/* CTA */}
              <div className="sx-bnr-readmore mt-4">
                <NavLink
                  to="/contact-us"
                  className="site-button sx-btn-primary icon"
                >
                  Request A Call
                </NavLink>
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="container">
          <div className="section-content">
            <div className="sx-our-service-detail">
              {/* Section Heading */}
              <div className="section-head2">
                <div className="sx-head-l-title">
                  <h2 className="sx-title2 text-center mt-5">
                    Custom Mobile App Development for Android & iOS Platforms
                  </h2>
                </div>
              </div>
              {/* Description */}
              <div className="sx-our-service-info m-b30 text-center">
                <p>
                  At <strong>DArch Tech</strong>, we specialize in building
                  <strong>
                    {" "}
                    high-performance, secure, and scalable mobile applications
                  </strong>
                  <br />
                  that help businesses engage users, streamline operations, and
                  drive digital growth.
                </p>

                <p>
                  Whether you need a startup MVP, enterprise-grade mobile
                  solution, or cross-platform app, our mobile app development
                  experts deliver
                  <br />
                  <strong>
                    {" "}
                    custom solutions aligned with your business objectives
                  </strong>
                  .
                </p>

                {/* Feature Icons */}
                <div className="sx-head-s-title h3 my-4 mt-5 pt-4 text-center">
                  Innovative & Scalable Mobile Solutions
                </div>
                <div className="row sx-about-icon-bx1-column p-t20 p-b20">
                  <div className="col-lg-4 col-md-6 m-b30">
                    <div className="sx-icon-bx-2">
                      <div className="sx-media">
                        <FaMobileAlt size={36} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">
                          App Strategy & Planning
                        </span>
                        <span className="sx-icon-bx-title-info">
                          Requirement Analysis & Roadmap
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 m-b30">
                    <div className="sx-icon-bx-2">
                      <div className="sx-media">
                        <FaAndroid size={32} />
                        <FaApple size={32} className="ms-2" />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">
                          Android & iOS Apps
                        </span>
                        <span className="sx-icon-bx-title-info">
                          Native & Cross-Platform
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 m-b30">
                    <div className="sx-icon-bx-2">
                      <div className="sx-media">
                        <FaPaintBrush size={36} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">UI/UX Design</span>
                        <span className="sx-icon-bx-title-info">
                          Intuitive & User-Centric Interfaces
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 m-b30">
                    <div className="sx-icon-bx-2">
                      <div className="sx-media">
                        <FaRocket size={36} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">
                          High Performance Apps
                        </span>
                        <span className="sx-icon-bx-title-info">
                          Speed, Stability & Scalability
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 m-b30">
                    <div className="sx-icon-bx-2">
                      <div className="sx-media">
                        <FaShieldAlt size={36} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">
                          Secure Applications
                        </span>
                        <span className="sx-icon-bx-title-info">
                          Data Protection & Compliance
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 m-b30">
                    <div className="sx-icon-bx-2">
                      <div className="sx-media">
                        <FaCloudUploadAlt size={36} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">
                          Deployment & Support
                        </span>
                        <span className="sx-icon-bx-title-info">
                          App Store & Play Store Launch
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Closing Paragraph */}
                <p>
                  Our mobile applications are built using
                  <strong>
                    {" "}
                    modern frameworks, secure architectures, and scalable
                    technologies{" "}
                  </strong>
                  to ensure long-term performance, seamless updates, and future
                  growth.
                </p>
              </div>

              {/* Counters */}
              <SectionCounter1 />

              {/* =========================
    MOBILE APP SERVICES – CARD FORMAT
========================== */}
              <h3 className="sx-title2 p-t30 text-center">
                Our Mobile App Development Services Include
              </h3>

              <div className="row m-t40">
                <div className="col-lg-4 col-md-6 m-b30">
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #d6edf2",
                      borderRadius: "8px",
                      padding: "25px",
                      height: "100%",
                    }}
                  >
                    <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                      Android App Development
                    </h4>
                    <p>
                      We develop secure, high-performance Android applications
                      tailored to your business needs. Our apps deliver smooth
                      user experiences across a wide range of Android devices.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 m-b30">
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #d6edf2",
                      borderRadius: "8px",
                      padding: "25px",
                      height: "100%",
                    }}
                  >
                    <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                      iOS App Development
                    </h4>
                    <p>
                      Our iOS app development services focus on creating
                      intuitive and scalable applications for Apple devices,
                      ensuring high performance, security, and App Store
                      compliance.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 m-b30">
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #d6edf2",
                      borderRadius: "8px",
                      padding: "25px",
                      height: "100%",
                    }}
                  >
                    <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                      Cross-Platform App Development
                    </h4>
                    <p>
                      We build cross-platform mobile apps that work seamlessly
                      across Android and iOS using a single codebase, reducing
                      development time and cost without compromising quality.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 m-b30">
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #d6edf2",
                      borderRadius: "8px",
                      padding: "25px",
                      height: "100%",
                    }}
                  >
                    <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                      Enterprise Mobile Applications
                    </h4>
                    <p>
                      We create enterprise-grade mobile applications that
                      improve internal operations, communication, and
                      productivity while remaining scalable and secure.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 m-b30">
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #d6edf2",
                      borderRadius: "8px",
                      padding: "25px",
                      height: "100%",
                    }}
                  >
                    <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                      E-commerce & On-Demand Apps
                    </h4>
                    <p>
                      We develop feature-rich e-commerce and on-demand mobile
                      apps that enable seamless transactions, real-time
                      tracking, and improved customer engagement.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 m-b30">
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #d6edf2",
                      borderRadius: "8px",
                      padding: "25px",
                      height: "100%",
                    }}
                  >
                    <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                      App Redesign & Modernization
                    </h4>
                    <p>
                      We revamp existing mobile applications to improve UI/UX,
                      performance, and functionality, helping modernize apps and
                      enhance user satisfaction.
                    </p>
                  </div>
                </div>
              </div>

              {/* FAQ SECTION START */}
              <div
                className="section-full p-t30 p-b80"
                style={{ backgroundColor: "#f5f8fa" }}
              >
                <div className="container">
                  {/* Section Heading */}
                  <div
                    className="section-head2 text-center"
                    style={{ color: "#116A7A" }}
                  >
                    <div
                      className="sx-head-s-title"
                      style={{ color: "#116A7A" }}
                    ></div>
                    <div className="sx-head-l-title">
                      <h2 className="sx-title2" style={{ color: "#116A7A" }}>
                        Mobile App Development FAQs
                      </h2>
                    </div>
                  </div>

                  {/* Accordion */}
                  <div className="accordion sx-accordion" id="mobileDevFaq">
                    {/* FAQ 1 */}
                    <div className="accordion-item">
                      <h3 className="accordion-header" id="faqOneMD">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOneMD"
                          aria-expanded="true"
                          aria-controls="collapseOneMD"
                          style={{
                            backgroundColor: "#e0f0f3",
                            color: "#116A7A",
                            fontWeight: "600",
                          }}
                        >
                          How long does it take to develop a mobile app?
                        </button>
                      </h3>
                      <div
                        id="collapseOneMD"
                        className="accordion-collapse collapse show"
                        data-bs-parent="#mobileDevFaq"
                      >
                        <div className="accordion-body">
                          Development timelines depend on app complexity.
                          <strong> Simple apps may take 4–8 weeks</strong>,
                          while
                          <strong> complex apps may take 12–20 weeks</strong>.
                        </div>
                      </div>
                    </div>

                    {/* FAQ 2 */}
                    <div className="accordion-item">
                      <h3 className="accordion-header" id="faqTwoMD">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwoMD"
                          aria-expanded="true"
                          aria-controls="collapseTwoMD"
                          style={{
                            backgroundColor: "#e0f0f3",
                            color: "#116A7A",
                            fontWeight: "600",
                          }}
                        >
                          Do you develop apps for both Android and iOS?
                        </button>
                      </h3>
                      <div
                        id="collapseTwoMD"
                        className="accordion-collapse collapse show"
                        data-bs-parent="#mobileDevFaq"
                      >
                        <div className="accordion-body">
                          Yes. We offer{" "}
                          <strong>cross-platform development</strong> and native
                          apps for <strong>Android and iOS</strong>.
                        </div>
                      </div>
                    </div>

                    {/* FAQ 3 */}
                    <div className="accordion-item">
                      <h3 className="accordion-header" id="faqThreeMD">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThreeMD"
                          aria-expanded="true"
                          aria-controls="collapseThreeMD"
                          style={{
                            backgroundColor: "#e0f0f3",
                            color: "#116A7A",
                            fontWeight: "600",
                          }}
                        >
                          Will you provide app maintenance and updates?
                        </button>
                      </h3>
                      <div
                        id="collapseThreeMD"
                        className="accordion-collapse collapse show"
                        data-bs-parent="#mobileDevFaq"
                      >
                        <div className="accordion-body">
                          Yes. We provide
                          <strong>
                            {" "}
                            maintenance, feature updates, bug fixes, and
                            performance optimization
                          </strong>
                          .
                        </div>
                      </div>
                    </div>

                    {/* FAQ 4 */}
                    <div className="accordion-item">
                      <h3 className="accordion-header" id="faqFourMD">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFourMD"
                          aria-expanded="true"
                          aria-controls="collapseFourMD"
                          style={{
                            backgroundColor: "#e0f0f3",
                            color: "#116A7A",
                            fontWeight: "600",
                          }}
                        >
                          Can you integrate third-party APIs into the app?
                        </button>
                      </h3>
                      <div
                        id="collapseFourMD"
                        className="accordion-collapse collapse show"
                        data-bs-parent="#mobileDevFaq"
                      >
                        <div className="accordion-body">
                          Absolutely. We integrate
                          <strong>
                            {" "}
                            payment gateways, analytics, social media, and other
                            third-party APIs
                          </strong>
                          .
                        </div>
                      </div>
                    </div>

                    {/* FAQ 5 */}
                    <div className="accordion-item">
                      <h3 className="accordion-header" id="faqFiveMD">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFiveMD"
                          aria-expanded="true"
                          aria-controls="collapseFiveMD"
                          style={{
                            backgroundColor: "#e0f0f3",
                            color: "#116A7A",
                            fontWeight: "600",
                          }}
                        >
                          Do you design the app UI/UX as well?
                        </button>
                      </h3>
                      <div
                        id="collapseFiveMD"
                        className="accordion-collapse collapse show"
                        data-bs-parent="#mobileDevFaq"
                      >
                        <div className="accordion-body">
                          Yes. We create
                          <strong>
                            {" "}
                            intuitive and engaging UI/UX designs
                          </strong>{" "}
                          to enhance user experience.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* FAQ SECTION END */}
            </div>
          </div>
        </div>
      </div>
      {/* SERVICE DETAIL SECTION END */}

      {/* Supporting Sections */}
      {/* <SectionVideo2 /> */}
      {/* <SectionWhyChooseUs4 /> */}
      {/* <SectionClients2 /> */}
    </>
  );
}

export default MobileAppDevelopmentServicePage;
